import { render } from "./InputImageFile.vue?vue&type=template&id=6f1cc4d1&scoped=true&ts=true"
import script from "./InputImageFile.vue?vue&type=script&lang=ts"
export * from "./InputImageFile.vue?vue&type=script&lang=ts"

import "./InputImageFile.vue?vue&type=style&index=0&id=6f1cc4d1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1cc4d1"]])

export default __exports__